import { render, staticRenderFns } from "./siteCard.vue?vue&type=template&id=2c32c4f6"
import script from "./siteCard.vue?vue&type=script&lang=js"
export * from "./siteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports